export default (x: string): number => parseFloat(x.replace(/[^\d.]/g, ""));
